export default __webpack_public_path__ + "static/Watch together-b2fa2bc9248744e8a53632b9310bccd7.jpg";